const initialState = {
    id: undefined,
    mrnField: undefined,
    dobField: undefined,
    createNewRecords: false
};

const questionnaire = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default questionnaire;